import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl'
import { each } from 'lodash'

import { callApi } from '../services/fetchService'
import { loadGlobals } from '../actions'

import FaIcon from '../components/FaIcon'
import DataTable from '../components/DataTable'
import TableButton from '../components/TableButton'
import { Button, Modal, Form, Input, message } from 'antd'
const FormItem = Form.Item



const combos = {
    countries: { api: "country", i18n: "countries" },
    pathologies: { api: "pathology", i18n: "pathologies" },
    "pharmaceutical-forms": { api: "pharmaceutical-forms", i18n: "pharmaceuticalForms" },
    "action-categories": { api: "action-categories", i18n: "actionCategories" }
}



class _ItemModal extends Component {
    
    handleOk = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onOk(values).then(this.props.form.resetFields)
            }
        })
    }

    handleCancel = () => {
        this.props.form.resetFields()
        this.props.onCancel()
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { intl, comboName, item } = this.props
        const i18nCombo = combos[comboName].i18n

        return (
            <Modal title={<FormattedMessage id={"settings." + i18nCombo + "."  + (item ? 'update' : 'add')} />} visible={this.props.visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                <Form layout="vertical">
                    <FormItem label={<FormattedMessage id={"settings." + i18nCombo + ".valueColumn"} />}>
                        {getFieldDecorator('value', {
                            initialValue: item ? item.value : null,
                            rules: [
                                {required: true, message: intl.formatMessage({id: 'settings.' + i18nCombo + '.nameRequired'})}
                            ]
                        })(<Input />)}
                    </FormItem>
                    <FormItem label={<FormattedMessage id={"settings." + i18nCombo + ".keyColumn"} />}>
                        {getFieldDecorator('key', {
                            initialValue: item ? item.key : null,
                            rules: [
                                {required: true, message: intl.formatMessage({id: 'settings.' + i18nCombo + '.keyRequired'})}
                            ]
                        })(<Input disabled={item !== null} />)}
                    </FormItem>
                </Form>
            </Modal>
        )
    }
}

const ItemModal = injectIntl(Form.create()(_ItemModal))


class SettingsGenericCombo extends Component {

    state = {
        comboName: null,
        data: [],
        loading: false,
        modalVisible: false,
        modalItem: null
    }

    static propTypes = {
        loadGlobals: PropTypes.func.isRequired,
        intl: intlShape.isRequired,
        match: PropTypes.object.isRequired
    }

    fetch = (params = {}) => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'settings/' + combos[this.state.comboName].api
        }).then((data) => {
            this.setState({
                data: each(data, (item) => item.editable = false),
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.comboName !== nextProps.match.params.name) {
            this.setState({ comboName: nextProps.match.params.name }, this.fetch)
        }
    }

    componentWillMount() {
        this.setState({ comboName: this.props.match.params.name })
    }

    componentDidMount() {
        this.fetch()
    }

    delete = (setting) => {
        const { intl, loadGlobals } = this.props
        callApi({
            endpoint: 'settings/' + combos[this.state.comboName].api + '/' + setting.id,
            method: 'DELETE'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.deleteSuccess'}))
            this.fetch()
            loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    /**
     * Modal handling
     */
    showModal = (item) => {
        if (!item || item.id === undefined) {
            item = null
        }
        this.setState({modalVisible: true, modalItem: item})
    }
    cancelModal = () => {
        this.setState({modalVisible: false, modalItem: null})
    }
    okModal = (item) => {
        const { intl, loadGlobals } = this.props
        const { comboName } = this.state
        item.name = combos[comboName].api
        // Update
        if (this.state.modalItem) {
            item.id = this.state.modalItem.id
            return callApi({
                endpoint: 'settings/' + combos[comboName].api + '/' + item.id,
                method: 'POST',
                body: item
            }).then((data) => {
                message.success(intl.formatMessage({id: 'misc.updateSuccess'}))
                this.setState({modalVisible: false})
                this.fetch()
                loadGlobals()
            }).catch((data) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                return Promise.reject()
            })
        }
        // Insert
        else {
            return callApi({
                endpoint: 'settings/' + combos[comboName].api,
                method: 'PUT',
                body: item
            }).then((data) => {
                message.success(intl.formatMessage({id: 'misc.insertSuccess'}))
                this.setState({modalVisible: false})
                this.fetch()
                loadGlobals()
            }).catch((data) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                return Promise.reject()
            })
        }
    }

    /**
     * Render view
     */
    render() {
        const { data, loading, modalVisible, comboName, modalItem } = this.state
        const i18nCombo = combos[comboName].i18n

        const columns = [
            { title: "settings." + i18nCombo + ".valueColumn", dataIndex: "value", type: "string", sorter: true },
            { title: "settings." + i18nCombo + ".keyColumn", dataIndex: "key", type: "string", sorter: true },
            { title: "misc.actions", width: "100px", key: "action", render: (record) => (
                <span>
                    <TableButton color="blue" icon="pencil" onClick={this.showModal} value={record} />
                    <TableButton color="red" icon="trash-alt" onClick={this.delete} value={record} confirm />
                </span>
            ) }
        ]

        return (
            <div>
                <h1><FaIcon icon="cogs" fixedWidth /> <FormattedHTMLMessage id={"settings." + i18nCombo + ".title"} /></h1>
                <div className="action-bar"><Button onClick={this.showModal}><FaIcon icon="plus"/> <FormattedMessage id={"settings." + i18nCombo + ".add"} /></Button></div>
                <ItemModal visible={modalVisible} item={modalItem} onOk={this.okModal} onCancel={this.cancelModal} comboName={comboName} />
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" />
            </div>
        )
    }

}

export default withRouter(injectIntl(connect(null, {
    loadGlobals
})(SettingsGenericCombo)))



// WEBPACK FOOTER //
// ./src/views/SettingsGenericCombo.js